<div class="media-library-container">

    <!-- Toolbar -->
    <div class="media-toolbar">
        <div class="toolbar-left">
            <select class="form-select w-auto" style="height: 36px;">
                <option>All media items</option>
                <option>Images</option>
            </select>
            <select class="form-select w-auto" style="height: 36px;">
                <option>All dates</option>
            </select>
            <button class="btn-action" (click)="getImages()">Bulk Select</button>
        </div>

        <div class="toolbar-right">
            <div class="search-box">
                <mat-icon>search</mat-icon>
                <input type="text" [(ngModel)]="searchText" placeholder="Search" (keyup.enter)="getImages()">
            </div>

            <div class="view-switch">
                <button [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'" matTooltip="Grid View">
                    <mat-icon>grid_view</mat-icon>
                </button>
                <button [class.active]="viewMode === 'list'" (click)="viewMode = 'list'" matTooltip="List View">
                    <mat-icon>view_list</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Scrollable Content Area -->
    <div class="media-content-area">

        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="medialoader || mediaService.visibleloader">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <!-- Empty State -->
        <div *ngIf="visible_data && !medialoader && !mediaService.visibleloader" class="text-center p-5">
            <h3>No media items found.</h3>
        </div>

        <!-- Grid View -->
        <div class="media-grid-view" *ngIf="viewMode === 'grid' && !visible_data">
            <div class="media-item"
                *ngFor="let image of mediaService.images | paginate: { itemsPerPage: count, currentPage: page, totalItems: rowCount}"
                [class.selected]="appService.Data.selectedIMG.includes(image)"
                (click)="addToSelectedIMG(image, !appService.Data.selectedIMG.includes(image))">

                <img [src]="image.Medium" [alt]="image.original_filename"
                    onerror="this.src='assets/images/icons/small_no_img.png'">

                <div class="check-overlay">
                    <mat-icon>check</mat-icon>
                </div>

                <div class="remove-btn" *ngIf="appService.Data.role_id==1 || appService.Data.user_id==image.created_by"
                    (click)="openDeleteComponent(image.resource_id); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                </div>

                <div class="copy-btn" (click)="copyLink(image.Medium); $event.stopPropagation()" matTooltip="Copy URL">
                    <mat-icon>content_copy</mat-icon>
                </div>

                <div class="item-info">
                    {{image.original_filename}}
                </div>
            </div>
        </div>

        <!-- List View -->
        <div class="media-list-view" *ngIf="viewMode === 'list' && !visible_data">
            <table>
                <thead>
                    <tr>
                        <th width="80">File</th>
                        <th>Filename</th>
                        <th>Date</th>
                        <th width="100">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let image of mediaService.images | paginate: { itemsPerPage: count, currentPage: page, totalItems: rowCount}">
                        <td>
                            <img [src]="image.Medium" class="img-preview"
                                onerror="this.src='assets/images/icons/small_no_img.png'">
                        </td>
                        <td>
                            <strong>{{image.original_filename}}</strong>
                            <div class="actions">
                                <a class="text-primary">Edit</a> |
                                <a class="text-danger delete"
                                    *ngIf="appService.Data.role_id==1 || appService.Data.user_id==image.created_by"
                                    (click)="openDeleteComponent(image.resource_id)">Delete permanantly</a> |
                                <a class="text-secondary" (click)="copyLink(image.Medium)">Copy URL</a> |
                                <a class="text-secondary" [href]="image.Medium" target="_blank">View</a>
                            </div>
                        </td>
                        <td>{{ image.created_at | date:'mediumDate' }}</td>
                        <td>
                            <!-- Actions are now inline on hover, simplified column -->
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="openDeleteComponent(image.resource_id)">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                </button>
                            </mat-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Footer / Pagination -->
    <div class="media-footer">
        <div class="footer-left">
            <span *ngIf="rowCount > 0">{{rowCount}} items</span>
        </div>

        <div class="footer-right">
            <!-- Items Per Page -->
            <select class="form-select w-auto me-3" style="height: 30px; padding: 0 10px; font-size: 13px;"
                [ngModel]="count" (ngModelChange)="changeCount($event)">
                <option *ngFor="let c of counts" [value]="c">{{c}} per page</option>
            </select>

            <!-- Custom Pagination -->
            <div class="pagination-controls">
                <button [disabled]="page <= 1" (click)="onPageChanged(1)" matTooltip="First Page">«</button>
                <button [disabled]="page <= 1" (click)="onPageChanged(page - 1)">‹</button>

                <span>Page</span>
                <input type="number" class="current-page-input" [(ngModel)]="page" (keydown.enter)="onPageChanged(page)"
                    (blur)="onPageChanged(page)" min="1" [max]="rowCount">
                <span>of {{ (rowCount / count) | number:'1.0-0' }}</span>

                <button [disabled]="page * count >= rowCount" (click)="onPageChanged(page + 1)">›</button>
                <button [disabled]="page * count >= rowCount" (click)="onPageChanged(rowCount)">»</button>
            </div>

            <!-- Hidden original pagination controls to keep pipe working if strictly needed, 
                 but we are manually controlling page. 
                 Actually, ngx-pagination needs the control component to update the pipe state?
                 Or we can just update 'page' variable which the pipe watches. 
                 The pipe 'currentPage: page' binding handles the view slice.
            -->
        </div>
    </div>

</div>